import React, { Component } from 'react';

import Template from '../_core/controllers/Template';
import Link from '../_core/components/Link';
import Data from '../_core/models/Data';
import FadeIn from '../_core/components/FadeIn';
import ToolTip from '../_core/components/ToolTip';
import SiteModifier from '../_core/components/SiteModifier';


class Layout extends Component {

	constructor(props) {
		super(props);

	}

	
	/*

		RENDER

	*/

	render() {

		return (
			<main data-layout className="Site-page">

				{/* Reset modifiers per page */}
				<SiteModifier demodifier="cursor,cursorLeft,cursorRight,click"  key={window.location.href} auto={true} />

				<Data>
					{
						({ENTRY,entries,SHOWINFO}) => {

							return (

						
								<React.Fragment>

									{
										(SHOWINFO) ? <SiteModifier modifier="info" demodifier="no-info,teaser"  key={'info'} auto={true} /> : <SiteModifier demodifier="info,teaser" modifier="no-info" key={'noinfo'}  auto={true} />
									}
									
									<h1 className="Site-title">{ENTRY ? ENTRY.title : 'Casswell Bank Architects'}</h1>

									
										<Template />
									
								</React.Fragment>
								
							)

						}
					}
				</Data>

			{/* 
			.Site-tooltip
			<ToolTip /> follows the mouse around automatically
			Content of the tooltip and whether to show or hide is stored in the global DATA store and set by other components (e.g. <Project.Chart />)
			*/}
            <ToolTip className={'Site-toolTip'} />
            {/* end .Site-tooltip */}

            </main>


		);

	}
}

export default Layout;



// WEBPACK FOOTER //
// ./src/js/templates/_layout.js